<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>权限管理</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="add">
      <el-button type="primary" @click="addShow = true"
        >新增<i class="el-icon-upload el-icon--right"></i
      ></el-button>
    </div>
    <el-table :data="userData" style="width: 100%">
      <el-table-column label="主键ID" prop="id"> </el-table-column>
      <el-table-column label="角色" prop="type"> </el-table-column>
      <el-table-column label="简称" prop="short_name"> </el-table-column>
      <el-table-column label="创建时间" prop="create_time"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="success" size="mini" @click="oppen(scope.row)"
            >查看权限</el-button
          >
          <el-button size="mini" @click="handleEdit(scope.row)">修改</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pagenum"
      :page-sizes="[1, 2, 5, 10]"
      :page-size="queryInfo.pagesize"
      layout="total, sizes, prev, pager, next"
      :total="total"
    >
    </el-pagination>
    <!-- 添加角色 -->
    <el-dialog title="添加" :visible.sync="addShow">
      <el-form :model="addForm" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="角色名称" prop="type">
          <el-input v-model="addForm.type"></el-input>
        </el-form-item>
        <el-form-item label="角色简称" prop="short_name">
          <el-input v-model="addForm.short_name"></el-input>
        </el-form-item>
        <el-form-item label="权限选择">
          <el-select @change="getPower()" v-model="type" placeholder="请选择">
            <el-option
              v-for="(item, index) in optionsList"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分配权限" prop="menuIds">
          <el-tree
            :props="defaultProps"
            :data="powerList"
            show-checkbox
            default-expand-all
            :default-checked-keys="addForm.menuIds"
            node-key="id"
            @check-change="handleChange"
          >
          </el-tree>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitAddForm('form')"
            >立即添加</el-button
          >
          <el-button @click="addShow = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 查看已有权限 -->
    <el-dialog title="已有权限" :visible.sync="showShow">
      <el-select @change="oppen1()" v-model="type" placeholder="请选择">
        <el-option
          v-for="(item, index) in optionsList"
          :key="index"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <el-tree :props="defaultPropss" :data="detailsList" default-expand-all>
      </el-tree>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog title="修改" :visible.sync="editShow">
      <el-form :model="editFrom" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="角色名称" prop="type">
          <el-input v-model="editFrom.type"></el-input>
        </el-form-item>
        <el-form-item label="角色简称" prop="short_name">
          <el-input v-model="editFrom.short_name"></el-input>
        </el-form-item>
        <el-form-item label="权限选择">
          <el-select @change="getPower()" v-model="type" placeholder="请选择">
            <el-option
              v-for="(item, index) in optionsList"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="分配权限" prop="menuIds">
          <el-tree
            :props="defaultProps"
            :data="powerList"
            show-checkbox
            default-expand-all
            node-key="id"
            :default-checked-keys="editFrom.menuIds"
            @check-change="handleChanges"
          >
          </el-tree>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitEditForm('form')"
            >立即修改</el-button
          >
          <el-button @click="addShow = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "role",
  data() {
    return {
      addShow: false,
      detailsShow: false,
      editShow: false,
      showShow: false,
      id: "",
      total: 0,
      // 获取用户列表的参数对象
      queryInfo: {
        query: "",
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少条数据
        pagesize: 10,
      },
      // 角色列表
      userData: [],
      // 权限列表
      powerList: [],
      // 权限目录
      optionsList: [],
      // 详情列表
      detailsList: [],

      rules: {
        type: [{ required: true, message: "请输入角色名称", trigger: "blur" }],
        short_name: [
          { required: true, message: "请输入角色简称", trigger: "blur" },
        ],
        menuIds: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change",
          },
        ],
      },
      type: "pc",
      defaultProps: {
        children: "childrens",
        label: "name",
        value: "name",
      },
      defaultPropss: {
        children: "childrens",
        label: "name",
      },
      addForm: {
        type: "",
        short_name: "",
        // 添加权限列表
        menuIds: [],
      },
      editFrom: {
        id: "",
        type: "",
        short_name: "",
        // 添加权限列表
        menuIds: [],
      },
    };
  },
  mounted: function () {
    this.getcaidan();
    this.getList();
    this.getPower();
  },
  methods: {
    // 监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.pagesize = newSize;
      this.getList();
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      console.log(newPage);
      this.queryInfo.pagenum = newPage;
      this.getList();
    },
    // 获取角色列表
    getList() {
      this.$fetch(
        "/authorization/managerIdentity/queryRoleList?state=1&pageSize=" +
          this.queryInfo.pagesize +
          "&currentPage=" +
          this.queryInfo.pagenum
      ).then((res) => {
        this.userData = res.data.rows;
        this.total = res.data.total;
        console.log("角色", this.userData);
      });
    },
    getcaidan() {
      this.$fetch("/authorization/menu/queryMenuType").then((res) => {
        this.optionsList = res.data;
        console.log("权限目录", this.optionsList);
      });
    }, 
    getPower() {
      this.$fetch("/authorization/menu/queryMenuList?type=" + this.type).then(
        (res) => {
          this.powerList = res.data;
          console.log("权限树", this.powerList);
        }
      );
    },
    // 查看详情
    oppen(row) {
      this.showShow = true;
      this.id = row.id;
      this.oppen1();
    },
    oppen1() {
      let urlList = "/authorization/menu/queryMenuListByIdentityId?id=";

      let urlTree = "/authorization/apiUrl/queryRoleIdentity?id=";
      this.$fetch(urlList + this.id + "&type=" + this.type).then((res) => {
        this.detailsList = res.data;
        // this.detailsList = res.data.rows;
        console.log("详情", this.detailsList);
      });
    },
    // 修改
    handleEdit(row) {
      this.editFrom.id = row.id;
      this.editFrom.type = row.type;
      this.editFrom.short_name = row.short_name;
      this.editShow = true;
    },
    // 删除
    handleDelete(row) {
      // 弹框询问用户是否直接删除数据
      let data = {};
      data.id = row.id;
      data.state = 0;
      this.$confirm("此操作将永久删除该角色, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$post("/authorization/managerIdentity/update", data).then(
            (res) => {
              if (res.code != 0) {
                return this.$message.error("删除角色失败!");
              } else {
                this.getList();
                return this.$message.success("删除角色成功!");
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleChange(data, checked, indeterminate) {
      //  console.log(data, checked, indeterminate);
      if (checked) {
        this.addForm.menuIds.push(data.id);
        console.log(this.addForm.menuIds);
      } else if(checked == false&&indeterminate ==false) {
        let index = this.addForm.menuIds.indexOf(data.id);
        this.addForm.menuIds.splice(index, 1);
        console.log(this.addForm.menuIds);
      }
    },
    handleChanges(data, checked, indeterminate) {
       console.log(data, checked, indeterminate);
      if (checked) {
        this.editFrom.menuIds.push(data.id);
        console.log(this.editFrom.menuIds);
      }else if(checked == false&&indeterminate ==false) {
        let index = this.editFrom.menuIds.indexOf(data.id);
        console.log(index);
        this.editFrom.menuIds.splice(index, 1);
        console.log(this.editFrom.menuIds);
      }
    },
    // 添加
    submitAddForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$post(
            "/authorization/managerIdentity/insert",
            this.addForm
          ).then((res) => {
            console.log(res);
            if (res.code == 0) {
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.getList();
              this.addShow = false;
              this.addForm = {};
            } else {
              this.$message({
                message: res.message,
              });
            }
          });
        } else {
          this.$message({
            message: "表单验证失败",
            type: "warning",
          });
          return false;
        }
      });
    },
    submitEditForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.editFrom);
          this.$post(
            "/authorization/managerIdentity/insert",
            this.editFrom
          ).then((res) => {
            console.log(res);

            if (res.code == 0) {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.getList();
              this.editFrom.menuIds = [];
              this.editShow = false;
            } else {
              this.$message({
                message: res.message,
              });
            }
          });
        } else {
          this.$message({
            message: "表单验证失败",
            type: "warning",
          });
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style scoped>
.add {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/guanli/role.vue